export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrayDown"] = 2] = "ArrayDown";
    IconSymbol[IconSymbol["AudioBus"] = 3] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 4] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 5] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 6] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 7] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 8] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 9] = "Book";
    IconSymbol[IconSymbol["Box"] = 10] = "Box";
    IconSymbol[IconSymbol["Browse"] = 11] = "Browse";
    IconSymbol[IconSymbol["Maximizer"] = 12] = "Maximizer";
    IconSymbol[IconSymbol["Bug"] = 13] = "Bug";
    IconSymbol[IconSymbol["Fold"] = 14] = "Fold";
    IconSymbol[IconSymbol["Checkbox"] = 15] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 16] = "Clips";
    IconSymbol[IconSymbol["Close"] = 17] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 18] = "CloudFolder";
    IconSymbol[IconSymbol["CollapseDown"] = 19] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 20] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 21] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 22] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 23] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 24] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 25] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 26] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 27] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 28] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 29] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 30] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 31] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 32] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 33] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 34] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 35] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 36] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 37] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 38] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 39] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 40] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 41] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 42] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 43] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 44] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 45] = "FileList";
    IconSymbol[IconSymbol["Film"] = 46] = "Film";
    IconSymbol[IconSymbol["Flask"] = 47] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 48] = "Focus";
    IconSymbol[IconSymbol["Gate"] = 49] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 50] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 51] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 52] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 53] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 54] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 55] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 56] = "Heart";
    IconSymbol[IconSymbol["Help"] = 57] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 58] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 59] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 60] = "Insert";
    IconSymbol[IconSymbol["Invert"] = 61] = "Invert";
    IconSymbol[IconSymbol["Info"] = 62] = "Info";
    IconSymbol[IconSymbol["Loop"] = 63] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 64] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 65] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 66] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 67] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 68] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 69] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 70] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 71] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 72] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 73] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 74] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 75] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 76] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 77] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 78] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 79] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 80] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 81] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 82] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 83] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 84] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 85] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 86] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 87] = "Panel";
    IconSymbol[IconSymbol["Peak"] = 88] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 89] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 90] = "Piano";
    IconSymbol[IconSymbol["Play"] = 91] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 92] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 93] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 94] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 95] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 96] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 97] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 98] = "Primary";
    IconSymbol[IconSymbol["Random"] = 99] = "Random";
    IconSymbol[IconSymbol["Record"] = 100] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 101] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 102] = "Redo";
    IconSymbol[IconSymbol["Region"] = 103] = "Region";
    IconSymbol[IconSymbol["Robot"] = 104] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 105] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 106] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 107] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 108] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 109] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 110] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 111] = "Search";
    IconSymbol[IconSymbol["Shadertoy"] = 112] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 113] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 114] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 115] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 116] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 117] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 118] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 119] = "Square";
    IconSymbol[IconSymbol["Stack"] = 120] = "Stack";
    IconSymbol[IconSymbol["Start"] = 121] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 122] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 123] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 124] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 125] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 126] = "Swap";
    IconSymbol[IconSymbol["System"] = 127] = "System";
    IconSymbol[IconSymbol["Table"] = 128] = "Table";
    IconSymbol[IconSymbol["Tape"] = 129] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 130] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 131] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 132] = "Timeline";
    IconSymbol[IconSymbol["Tool"] = 133] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 134] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 135] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 136] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 137] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 138] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 139] = "Vinyl";
    IconSymbol[IconSymbol["Volume"] = 140] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 141] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 142] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 143] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
